/* Fonts are attached here (parallel) rather than via CSS @import (chained). */
(function () {
  if (document.getElementById('pm-fonts')) { return; }
  var head = document.head;
  function link(rel, href, cross, id) {
    var l = document.createElement('link');
    l.rel = rel; l.href = href;
    if (cross) { l.crossOrigin = 'anonymous'; }
    if (id) { l.id = id; }
    head.appendChild(l);
  }
  link('preconnect', 'https://fonts.googleapis.com');
  link('preconnect', 'https://fonts.gstatic.com', true);
  link('stylesheet', 'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Inter:wght@400;500;600&display=swap', false, 'pm-fonts');
})();

window.PMCheckout = (function () {
  var primary = null;

  function productForm() {
    return document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]')
        || document.querySelector('form[action*="/cart/add"]');
  }

  function host() {
    var f = productForm();
    if (f && f.closest) {
      var s = f.closest('[id^="shopify-section-"]');
      if (s) { return s; }
    }
    return document.querySelector('[id^="shopify-section-"][id*="main-product"]');
  }

  function q(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qa(sel, root) { try { return (root || document).querySelectorAll(sel); } catch (e) { return []; } }
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  var FASTRR = [
    '.shiprocket-headless',
    '[class*="shiprocket-headless"]',
    '[class*="shiprocket" i]',
    '[class*="fastrr" i]',
    '[class*="boost-btn" i]',
    '[class*="boost_btn" i]',
    '[class*="pickrr" i]',
    '[class*="sr-checkout" i]'
  ];

  function fastrrSelectors() { return FASTRR; }

  function findFastrr(root) {
    for (var i = 0; i < FASTRR.length; i++) {
      var els = qa(FASTRR[i], root);
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        var tn = el.tagName;
        if (tn === 'INPUT' || tn === 'SCRIPT' || tn === 'STYLE' || tn === 'LINK') { continue; }
        var btn = (tn === 'BUTTON' || tn === 'A') ? el : el.querySelector('button, a, [role="button"]');
        if (btn) { return btn; }
        if (visible(el)) { return el; }
      }
    }
    return null;
  }

  function findNative(root) {
    var scope = root || document;
    return q('form[action*="/cart/add"] [name="add"]', scope)
        || q('[name="add"]', scope)
        || q('.product-form__submit', scope)
        || q('form[action*="/cart/add"] button[type="submit"]', scope);
  }

  function setPrimary(el) { if (el) { primary = el; } }
  function getPrimary() { return (primary && document.contains(primary)) ? primary : null; }

  function setVariant(id) {
    if (!id) { return; }
    var fields = qa('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    if (!fields.length) { fields = qa('input[name="id"], select[name="id"]'); }
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      f.value = id;
      try { f.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      try { f.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    }
    var h = host();
    if (h) {
      var radio = h.querySelector('input[type="radio"][value="' + id + '"]');
      if (radio && !radio.checked) { try { radio.click(); } catch (e) {} }
    }
  }

  function addToCart(id, qty, to) {
    if (!id) { return false; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function () { window.location.href = to || '/checkout'; })
      .catch(function () { window.location.href = '/cart'; });
    return true;
  }

  function go(opts) {
    opts = opts || {};
    setVariant(opts.variantId);
    var mode = opts.mode || 'forward';

    if (mode === 'url' && opts.url) { window.location.href = opts.url; return true; }
    if (mode === 'add_to_cart') { return addToCart(opts.variantId, opts.qty, '/checkout'); }

    var btn = null;
    if (opts.selector) {
      var s = String(opts.selector).trim();
      if (s) { btn = q(s); }
    }
    if (!btn) { btn = getPrimary(); }
    if (!btn) { btn = findFastrr(document); }
    if (!btn) { btn = findNative(document); }

    if (btn) { setTimeout(function () { try { btn.click(); } catch (e) {} }, 60); return true; }
    return addToCart(opts.variantId, opts.qty, '/checkout');
  }

  return {
    go: go, addToCart: addToCart, setVariant: setVariant,
    setPrimary: setPrimary, getPrimary: getPrimary,
    findFastrr: findFastrr, findNative: findNative,
    fastrrSelectors: fastrrSelectors, host: host, productForm: productForm,
    find: function () { return getPrimary() || findFastrr(document) || findNative(document); }
  };
})();
